import YoutubeLink from "./YoutubeLink";
import TextMode from "./TextMode";
import { useState } from "react";
import styles from"./MainPage.module.css";
import logo from "./Icons/seo.png";
import { Link } from "react-router-dom";

const MainPage = () => {

    const [mode, setMode] = useState("text");

    function changeMode(mode) {
        if(mode === "text") {
            setMode("text");
            document.getElementById("textOption").style.color = "#EAEAEA";
            document.getElementById("textOption").style.backgroundColor = "#53354A";
            document.getElementById("linkOption").style.color = "#53354A";
            document.getElementById("linkOption").style.backgroundColor = "#EAEAEA";
        }
        else {
            setMode("link");
            document.getElementById("linkOption").style.color = "#EAEAEA";
            document.getElementById("linkOption").style.backgroundColor = "#53354A";
            document.getElementById("textOption").style.color = "#53354A";
            document.getElementById("textOption").style.backgroundColor = "#EAEAEA";
        }
    }   

    return (
        <div className = {styles.body}>
            <div className = {styles.navbar}>
                <Link to = "/" className = {styles.home}>HOME</Link>
                <img className = {styles.logo} src = {logo} alt = "logo" />
                <h1 className = {styles.title}>
                    TruthCreds
                </h1>
            </div>
            <div className = {styles.modePanel}>
                <h1 id = "textOption" style={{"color" : "#EAEAEA", "backgroundColor" : "#53354A"}} className = {styles.modeOption} onClick={() => {changeMode("text")}}>Text</h1>
                <h1 id = "linkOption" className = {styles.modeOption} onClick={() => {changeMode("link")}}>YouTube Link</h1>
            </div>
            {mode === "text" 
                ? <TextMode />
                : <YoutubeLink />
            }
            
        </div>
        
    )
}

export default MainPage;